import React from "react";
import { FormatNumberOptions, FormattedNumber, IntlShape } from "react-intl";

export type IMoney = {
    readonly amount: number;
    readonly currency: string | null;
};

type IDisplayMoneyProps = {
    format?: string;
};

type IMoneyProps = IMoney & IDisplayMoneyProps;

const fractionDigitLength: number = 2;
const threeLetterIsoLength: number = 3;

export const Money: React.FC<IMoneyProps> = ({ amount, currency, format }) => {
    const resolvedCurrency = UseCurrencyOrDefault(currency);

    return (
        <FormattedNumber
            value={amount}
            currency={resolvedCurrency}
            format={format}
            maximumFractionDigits={fractionDigitLength}
            minimumFractionDigits={fractionDigitLength}
            style="currency"
        >
            {(formattedValue: React.ReactNode) => (
                <span className="money-wrapper">
                    <span aria-hidden="true">{formattedValue}</span>
                    <span className="sr-only">
                        <FormattedNumber
                            value={amount}
                            currency={resolvedCurrency}
                            format={format}
                            style="currency"
                            currencyDisplay="name"
                            maximumFractionDigits={fractionDigitLength}
                            minimumFractionDigits={fractionDigitLength}
                        />
                    </span>
                </span>
            )}
        </FormattedNumber>
    );
};

export const UseCurrencyOrDefault = (currency: string | null | undefined): string => {
    const defaultThreeLetterIsoCurrency: string = "usd";
    return currency && currency.length === threeLetterIsoLength ? currency : defaultThreeLetterIsoCurrency;
};

export type FormatMoneyParts = {
    intl: IntlShape,
    money: IMoney,
    format?: string,
};

export const TryCurrencyFormat = (formatMoneyParts: FormatMoneyParts): string => {
    const options: FormatNumberOptions = {
        currency: UseCurrencyOrDefault(formatMoneyParts.money.currency),
        format: formatMoneyParts.format,
        style: "currency",
    };
    return formatMoneyParts.intl.formatNumber(formatMoneyParts.money.amount, options);
};
